module.exports = __webpack_public_path__ + "img/logo.751ea287.png";